import { render } from "./LeaderboardsView.vue?vue&type=template&id=8c6dc780&scoped=true"
import script from "./LeaderboardsView.vue?vue&type=script&lang=js"
export * from "./LeaderboardsView.vue?vue&type=script&lang=js"

import "./LeaderboardsView.vue?vue&type=style&index=0&id=8c6dc780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6dc780"]])

export default __exports__